"use client";

import React, { useState } from "react";
import PolicyCard from "./PolicyCard";
import { Button } from "src/components/buttons/shadcn-button";

interface Policy {
  id: number;
  title: string;
  file: string;
}

const policies: Policy[] = [
  {
    id: 1,
    title: "Attendance Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/ATTENDANCE+POLICY.pdf",
  },
  {
    id: 2,
    title: "Compensation and Benefits Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/COMPENSATON+%26+BENEFITS+POLICY.pdf",
  },
  {
    id: 3,
    title: "Confidentiality Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/CONFIDENTIALITY+POLICY.pdf",
  },
  {
    id: 4,
    title: "Disciplinary Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/DISCIPLINARY+POLICY.pdf",
  },
  {
    id: 5,
    title: "Equal Opportunity Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/EQUAL+OPPORTUNITIES+POLICY.pdf",
  },
  {
    id: 6,
    title: "Grievance Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/GRIEVANCE+POLICY.pdf",
  },
  {
    id: 7,
    title: "Hiring Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/HIRING+POLICY.pdf",
  },
  {
    id: 8,
    title: "IT and Information Security Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/IT+%26+INFORMATION+SECURITY+POPICY.pdf",
  },
  {
    id: 9,
    title: "Leave Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/LEAVE+POLICY.pdf",
  },
  {
    id: 10,
    title: "Non-discrimination Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/NON-DISCRIMINATION+POLICY.pdf",
  },
  {
    id: 11,
    title: "Performance Management Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/PERFORMANCE+MANAGEMENT+POLICY.pdf",
  },
  {
    id: 12,
    title: "Separation & Notice Period Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/SEPARATION+%26+NOTICE+PERIOD+POLICY.pdf",
  },
  {
    id: 13,
    title: "Termination Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/TERMINATION+POLICY.pdf",
  },
  {
    id: 14,
    title: "Travel Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/TRAVEL+POLICY.pdf",
  },
  {
    id: 15,
    title: "Warning Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/WARNING+POLICY.pdf",
  },
  {
    id: 16,
    title: "Work From Home Policy",
    file: "https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/WORK+FROM+HOME+POLICY.pdf",
  },
];

const Policies = () => {
  const [startIndex, setStartIndex] = useState<number>(0);
  const policiesPerPage = 4;

  const currentPolicies = policies.slice(startIndex, startIndex + policiesPerPage);

  const handleNext = () => {
    if (startIndex + policiesPerPage < policies.length) {
      setStartIndex(startIndex + policiesPerPage);
    }
  };

  const handlePrev = () => {
    if (startIndex - policiesPerPage >= 0) {
      setStartIndex(startIndex - policiesPerPage);
    }
  };

  return (
    <div className="bg-gray-100 p-6 flex justify-center py-2 px-1 sm:px-6 lg:px-1">
      <div className="max-w-4xl w-full space-y-8">
        <h1 className="text-2xl font-extrabold text-gray-900 text-center">
          Company Policies
        </h1>

        {/* Grid shows only 4 items at a time */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 transition-transform duration-500">
          {currentPolicies.map((policy) => (
            <PolicyCard key={policy.id} {...policy} />
          ))}
        </div>

        {/* Pagination Buttons */}
        <div className="flex justify-center items-center gap-10">
          <Button
            className="px-4 py-2 disabled:opacity-50"
            onClick={handlePrev}
            disabled={startIndex === 0}
          >
            Prev
          </Button>
          <Button
            className="px-4 py-2 disabled:opacity-50"
            onClick={handleNext}
            disabled={startIndex + policiesPerPage >= policies.length}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Policies;
